import { render, staticRenderFns } from "./UploadCropper.vue?vue&type=template&id=3da86eb5"
import script from "./UploadCropper.vue?vue&type=script&lang=js"
export * from "./UploadCropper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports